module.exports = __webpack_public_path__ + "static/media/Offers@3x.71d82ca2.png";